export const wsgtdriveTableColumns = [
  {
    label: "Campaign ID",
    field: "id",
    type: "number",
  },
  {
    label: "Campaign Name",
    field: "name",
  },
  {
    label: "Start Date",
    field: "start_date",
    type: "date",
    dateInputFormat: "yyyy-MM-dd HH:mm:ss",
    dateOutputFormat: "yyyy-MM-dd HH:mm:ss",
  },
  {
    label: "End Date",
    field: "end_date",
    type: "date",
    dateInputFormat: "yyyy-MM-dd HH:mm:ss",
    dateOutputFormat: "yyyy-MM-dd HH:mm:ss",
  },
  {
    label: "Status",
    field: "status",
    type: "string",
  },
  {
    label: "Last Modified",
    field: "modified_time",
  },
  {
    label: "Modifield By",
    field: "modified_by_username",
  },
];
